// extracted by mini-css-extract-plugin
module.exports = {"IRAFooter":"IRAFooter_IRAFooter__QJNSh"};